import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';
import { ReadConfigService } from '../common/read-config.service';

@Injectable()

export class ScheduleService {
  constructor(private httpClient: HttpClient, private readConfigService: ReadConfigService) { }
  apiUrl = this.readConfigService.getApiUrl();
  apiTimeout = this.readConfigService.getApiTimeout();
  httpOption = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  getFYList(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_FISCAL_YEAR_LIST_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  // GETS HISTORY RECORDS BASED ON ORGANIZATION ID
  getScheduleList(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_SCHEDULE_LIST_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  // GETS SYSTEM/PAY FREQUENCY AND LOCATIONS
  getScheduleInputs(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_INPUT_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  // GETS SCHEDULE ENTRIES FOR VIEW
  getScheduleEntries(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_SCHEDULE_ENTRIES_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  // GENERATES PAYSCHEDULE ENTRIES FOR CREATE AND CONTINUE PARTIAL
  generateScheduleEntrys(model: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_GENERATE_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, model)
      .pipe(this.handleError());
  }

  // SAVES NEW PAYSCHEDULE TO DB
  createSchedule(model: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_SAVE_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, model)
      .pipe(this.handleError());
  }

  // GET SCHEDULE DETAILS FOR EDIT AND FULL SCHEDULES
  getSchedules(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_LOAD_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  // GET PARTIAL SCHEDULE
  getPartialSch(model: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_CONTINUE_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, model)
      .pipe(this.handleError());
  }

  post(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_UPDATE_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, obj)
      .pipe(this.handleError());
  }

  delete(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_DELETE_SCHEDULE_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  // SERVICE CALLS FOR VALIDATIONS
  getHolidays(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_GET_HOLIDAYS_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  nameExists(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_SCHEDULE_NAME_EXISTS_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  empScheduleIdExists(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_SCHEDULE_ID_EXISTS_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  updateEmpSchId(obj: any): Observable<any> {
    const url = this.apiUrl + Global.BASE_UPDATE_SCHEDULE_ID_EXISTS_ENDPOINT;
    return this.httpClient.post<any>(url, obj, this.httpOption)
      .pipe(this.handleError());
  }

  handleError() {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((v: any) => {
        if (v) {
          return v;
        }
      });
  }
}
